"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.hasOpenProposal = exports.canEditUsers = exports.showIfOneOf = exports.requiresOneOf = exports.requiresRoles = exports.getLoggedInUserAccess = exports.getCurrentUserAccessRoles = exports.currentUserIsSuper = exports.isSuperUserOrSME = exports.isSuperUser = exports.getStartOfFY = exports.datesCrossFY = exports.getLoggedInUser = exports.getLoggedInUserId = exports.getCurrentUserId = exports.getRefreshToken = exports.getAuthToken = exports.getCurrentUser = exports.dateTimeFormat = void 0;
var constants_1 = require("./constants");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var dayjs_1 = __importDefault(require("dayjs"));
var User_1 = __importDefault(require("./User"));
var cookies = new universal_cookie_1["default"]();
exports.dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
var env = (process['env'] && process['env']['REACT_APP_GRAPHQL_URL']) ? process['env'] : window['_env_'];
/**
* Get the current user (actual logged in user)
* @return {Promise<BasicUserInfo>} - The user info
*/
function getCurrentUser() {
    var user_id = getCurrentUserId();
    if (!user_id) {
        return new Promise(function (resolve, reject) { return resolve(null); });
    }
    return User_1["default"].getBasicUserInfo(user_id);
}
exports.getCurrentUser = getCurrentUser;
/**
 * Get the current auth token
 * @return {string|undefined} Current Auth token
 */
function getAuthToken() {
    return cookies.get(constants_1.REF_KEYCLOAK_AUTH_TOKEN);
}
exports.getAuthToken = getAuthToken;
/**
 * Get the current refresh token
 * @return {string|undefined} Current Auth token
 */
function getRefreshToken() {
    return cookies.get(constants_1.REF_KEYCLOAK_REFRESH_TOKEN);
}
exports.getRefreshToken = getRefreshToken;
/**
 * Get the current user ID (actual logged in user)
 * @return {int} - user_id
 */
function getCurrentUserId() {
    var basicUserId = cookies.get(constants_1.REF_CURRENT_USER_ID);
    return parseInt(basicUserId, 10);
}
exports.getCurrentUserId = getCurrentUserId;
/**
 * Get the viewable user ID (current or impersonating in in user)
 * @return {int} - user_id
 */
function getLoggedInUserId() {
    return getCurrentUserId();
}
exports.getLoggedInUserId = getLoggedInUserId;
/**
 * Get the viewable user ID (current or impersonating in in user)
 * @return {Promise<BasicUserInfo>} - The user info
 */
function getLoggedInUser() {
    return getCurrentUser();
}
exports.getLoggedInUser = getLoggedInUser;
/**
 * @param {dayjs.Dayjs} start
 * @param {dayjs.Dayjs} end
 * @returns {boolean} TRUE if different FYs, else FALSE
 */
function datesCrossFY(start, end) {
    var getFYFromMoment = function (date) {
        var fy = date.year();
        if (date.month() >= 9) {
            fy++;
        }
        return fy;
    };
    return getFYFromMoment(start) !== getFYFromMoment(end);
}
exports.datesCrossFY = datesCrossFY;
/**
 * Return start of fiscal year
 */
function getStartOfFY() {
    var currentDate = (0, dayjs_1["default"])();
    var currentYear = currentDate.year();
    var currentMonth = currentDate.month() + 1;
    var year = currentMonth > 9 ? currentYear : currentYear - 1;
    return (0, dayjs_1["default"])("".concat(year, "-10-01")).startOf('day').format(exports.dateTimeFormat);
}
exports.getStartOfFY = getStartOfFY;
/**
 * Return true is user has Super User role
 * @param {array}
 * @return {boolean}
 */
var isSuperUser = function (userRoles) {
    return userRoles.includes(constants_1.ROLE_SUPER);
};
exports.isSuperUser = isSuperUser;
/**
 * Return true if current user has Super user role OR an SME role
 * @param {array}
 * @returns {boolean}
 */
var isSuperUserOrSME = function (userRoles) {
    var superUserOrSME = [constants_1.ROLE_SUPER, constants_1.ROLE_ENVIRON, constants_1.ROLE_ANIMAL_CARE, constants_1.ROLE_RAD_ENGINEERING, constants_1.ROLE_BIOLOGICAL, constants_1.ROLE_RISK,
        constants_1.ROLE_HUMAN, constants_1.ROLE_COUNTER_INTELLIGENCE, constants_1.ROLE_EXPORT_CONTROL, constants_1.ROLE_EQUIPMENT];
    return userRoles.some(function (role) { return superUserOrSME.includes(role); });
};
exports.isSuperUserOrSME = isSuperUserOrSME;
/**
 * Return true if current user has Super User role
 * @return {boolean}
 */
function currentUserIsSuper() {
    return __awaiter(this, void 0, void 0, function () {
        var currentUser;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLoggedInUser()];
                case 1:
                    currentUser = _a.sent();
                    return [2 /*return*/, currentUser && (0, exports.isSuperUser)(currentUser.access)];
            }
        });
    });
}
exports.currentUserIsSuper = currentUserIsSuper;
/**
 * Return CurrentUser's Access Roles
 * @return {string[]}
 */
function getCurrentUserAccessRoles() {
    return __awaiter(this, void 0, void 0, function () {
        var currentUser;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLoggedInUser()];
                case 1:
                    currentUser = _a.sent();
                    return [2 /*return*/, currentUser ? currentUser.access : []];
            }
        });
    });
}
exports.getCurrentUserAccessRoles = getCurrentUserAccessRoles;
/**
 * Get logged in user access
 * @return {AccessRoleInfo[]}
 */
function getLoggedInUserAccess() {
    return __awaiter(this, void 0, void 0, function () {
        var currentUser;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLoggedInUser()];
                case 1:
                    currentUser = _a.sent();
                    return [2 /*return*/, currentUser ? currentUser.access_info : []];
            }
        });
    });
}
exports.getLoggedInUserAccess = getLoggedInUserAccess;
/**
 * Requires all of the entered roles
 * @param {array|undefined}
 * @return {function}
 */
function requiresRoles(requiredRoles) {
    // If no requiredRoles or if user is SUPER, access is assumed => return null
    var access = function (userRoles) {
        if (!(0, exports.isSuperUser)(userRoles) || !requiredRoles || !requiredRoles.length) {
            if (requiredRoles) {
                var missingRoles = requiredRoles.filter(function (requiredRole) { return userRoles.indexOf(requiredRole) === -1; });
                if (missingRoles.length > 0) {
                    return "User does not have access to this page. Missing required role(s): ".concat(missingRoles.join(', '));
                }
            }
        }
        return null;
    };
    return access;
}
exports.requiresRoles = requiresRoles;
/**
 * Requires all of the entered roles
 * @param {array|undefined}
 * @return {function}
 */
function requiresOneOf(requiredRoles) {
    var access = function (userRoles) {
        // If no requiredRoles or if user is SUPER, access is assumed => return null
        if (!(0, exports.isSuperUser)(userRoles) && requiredRoles) {
            var missingRoles = requiredRoles.filter(function (requiredRole) { return userRoles.indexOf(requiredRole) === -1; });
            if (missingRoles.length === requiredRoles.length) {
                return "User does not have access to this page. Must have one of the following roles: ".concat(requiredRoles.join(', '));
            }
        }
        return null;
    };
    return access;
}
exports.requiresOneOf = requiresOneOf;
function showIfOneOf(requiredRoles) {
    var access = function (userRoles) {
        if (!(0, exports.isSuperUser)(userRoles)) {
            var missingRoles = requiredRoles.filter(function (requiredRole) { return userRoles.indexOf(requiredRole) === -1; });
            if (requiredRoles.length !== 0 && missingRoles.length === requiredRoles.length) {
                return false;
                // return `User does not have access to this page. Must have one of the following roles: ${requiredRoles.join(', ')}`;
            }
        }
        return true;
    };
    return access;
}
exports.showIfOneOf = showIfOneOf;
/**
 * Current user can edit users (via Manage Users)
 * @return {boolean} TRUE if yes, else FALSE
 */
function canEditUsers() {
    return __awaiter(this, void 0, void 0, function () {
        var currentUser, isServices, isAdmin;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLoggedInUser()];
                case 1:
                    currentUser = _a.sent();
                    if (!currentUser) {
                        return [2 /*return*/, false];
                    }
                    isServices = !requiresOneOf([constants_1.ROLE_SERVICES])(currentUser.access);
                    isAdmin = !requiresOneOf([constants_1.ROLE_ADMIN])(currentUser.access);
                    return [2 /*return*/, isServices || isAdmin];
            }
        });
    });
}
exports.canEditUsers = canEditUsers;
function hasOpenProposal(currentUser) {
    var openProposal = false;
    if (currentUser.projects) {
        var oneMonthAgo_1 = new Date();
        oneMonthAgo_1.setMonth(oneMonthAgo_1.getMonth() - 1);
        currentUser.projects.forEach(function (proposal) {
            if (!proposal.project_closed || (0, dayjs_1["default"])(proposal.project_closed) >= (0, dayjs_1["default"])(oneMonthAgo_1)) {
                openProposal = true;
            }
        });
    }
    return openProposal;
}
exports.hasOpenProposal = hasOpenProposal;
